import { render } from "./ModalUserData.vue?vue&type=template&id=af6839e8&scoped=true"
import script from "./ModalUserData.vue?vue&type=script&lang=js"
export * from "./ModalUserData.vue?vue&type=script&lang=js"

import "./ModalUserData.vue?vue&type=style&index=0&id=af6839e8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6839e8"]])

export default __exports__